import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { db, firebase } from '../firebase';
import * as routes from '../Constants/routes';
import DeckOptions from "./DeckOptions";


class DeckSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
        selectedDeck: "",
        tournaments: this.props.location.state.tournaments,
        tournamentId: "",
        participantId: "",
        ethPublicWallet: ""
     };

     this.deckChange = this.deckChange.bind(this);
     this.ethChange = this.ethChange.bind(this);
  }

  componentDidMount() {

//    this.setState = ({tournaments = this.props.location.state.})
    var search = this.props.location.search;
    const params = new URLSearchParams(search);
    const tId = params.get('tournamentId');
    if (tId != null){
      this.setState({tournamentId: tId})
    }

    const pId = params.get('participantId');
    if (pId != null){
      this.setState({participantId: pId})
    }

    this.setState({ethPublicWallet: this.context.ethWallet})
  }



  onSubmit = (event) => {
      var tUrl = this.state.tournamentId;
      var user = this.context.authUserId;
      var tourneyObj = this.state.tournaments;
      var deck = this.state.selectedDeck;
      var ethWallet = this.state.ethPublicWallet;

      var url = 'https://us-central1-novablitzhq-api.cloudfunctions.net/challongeTournamentCheckIn?tournamentId='
      + this.state.tournamentId + '&participantId=' + this.state.participantId

      fetch(url)
      .then(function(response) {
        return response.json();
      }).then(data => {
        _.forOwn(tourneyObj, function(value, key) {
          if (value.url == tUrl) {
                  value.checkedIn = true;
                  value.deck = deck;
                  value.ethWallet = ethWallet;
            }
        });

        db.updateUserTournaments(user, tourneyObj)
          .then(() => {
            this.setState(() => ({ checkedIn: true }));
        })

        alert("You are checked in, good luck!");

        this.props.history.push({
          pathname: routes.TOURNAMENTGRID
        });

     });

    event.preventDefault();
  }

  deckChange(event) {
    this.setState({selectedDeck: event.target.value})
  }

  ethChange(event) {
    this.setState({ethPublicWallet: event.target.value})
  }

  render() {
    const isInvalid = this.state.selectedDeck === "";

    const loginStyle = {
      marginTop: 50,
      backgroundColor: "white"
    };
    const h2Style = {
      paddingLeft: 10,
      paddingTop: 5,
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    };

    return (
    <div style={loginStyle}  className="Site_Content, container">
      <Form onSubmit={this.onSubmit}>
        <h2 style={h2Style}>Select your Deck</h2>

        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">Deck</Label>
          <Input  type="select" id="sDeck"  value={this.state.selectedDeck} onChange={this.deckChange} bsSize="sm">
            <option value=""></option>
            <DeckOptions />
          </Input>
        </FormGroup>

        <FormGroup className="mb-2 mr-sm-2 mb-sm-2 mr-1  mb-md-2 mb-lg-2 mb-xl-2">
          <Label className="ml-2 mr-sm-2">Public Eth Wallet</Label>
          <Input type="text" id="eth"  value={this.state.ethPublicWallet} onChange={this.ethChange} bsSize="sm">
          </Input>
        </FormGroup>
        <Label className="ml-2 mr-sm-2">Needed for Prize Distribution.  This defaults from your User Profile.</Label>
        <Button disabled={isInvalid} type="submit">
          Check In
        </Button>

      </Form>
    </div>

    );
  }
}

DeckSelect.contextTypes = {
  authUserId: PropTypes.string,
  ethWallet: PropTypes.string
};

export default DeckSelect;



// WEBPACK FOOTER //
// ./src/Tournaments/DeckSelect.js